import { SET_RULES_FEATURES } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_RULES_FEATURES:
      return action.payload;
    default:
      return state;
  }
};
